export default "__VITE_ASSET__BDEOe5_g__"